module.exports = __webpack_public_path__ + "static/gerry_gecko-b5e21e10ffec08e455943f89689a09eb.png";